import { H3 } from "@/components/reusables/typography";
import { cn } from "@/lib/utils";

interface ProductOverviewCardProps {
  label: string;
  value: string | number;
}
const ProductOverviewCard = ({
  label,
  value,
}: ProductOverviewCardProps): JSX.Element => (
  <div className='flex flex-col border border-input rounded-md p-2 space-y-2 '>
    <p className='text-lg font-semibold'>{label}</p>
    <H3 className='text-xl'>{value}</H3>
  </div>
);

const ProductOverview = ({
  data,
  className,
}: {
  data: ProductOverviewCardProps[];
  className?: string;
}): JSX.Element => {
  return (
    <section className={cn(" grid grid-cols-7 gap-4", className)}>
      {data.map((data, index) => (
        <ProductOverviewCard
          key={index}
          label={data.label}
          value={data.value}
        />
      ))}
    </section>
  );
};

export default ProductOverview;
